import React from "react";

// Components:
import Placeholder from "../Placeholder";

const Practice = () => {
  return <Placeholder title="Practice" />;
};

export default Practice;
